import React from "react";
const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="15"
    viewBox="0 0 10 15"
    fill="none"
  >
    <g clipPath="url(#clip0_6_2)">
      <path
        d="M4.29375 10.9746C4.68437 11.3408 5.31875 11.3408 5.70937 10.9746L9.70938 7.22461C9.99688 6.95508 10.0813 6.55371 9.925 6.20215C9.76875 5.85059 9.40625 5.62207 9 5.62207L1 5.625C0.596875 5.625 0.23125 5.85352 0.0750002 6.20508C-0.0812498 6.55664 0.00625017 6.95801 0.290625 7.22754L4.29063 10.9775L4.29375 10.9746Z"
        fill="#8704E9"
      />
    </g>
    <defs>
      <clipPath id="clip0_6_2">
        <rect width="10" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default icon;
